import React from 'react'
import classnames from 'classnames'

const ConfirmationIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    className={classnames('confirmation-icon', {
      [className]: !!className,
    })}
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path d="M35.0004 0C15.774 0 0.043335 15.7499 0.043335 35.0003C0.043335 54.2506 15.774 70.0005 35.0004 70.0005C54.2268 70.0005 69.9575 54.2506 69.9575 35.0003C69.9575 15.7499 54.2268 0 35.0004 0ZM35.0004 65.6252C18.1773 65.6252 4.41297 51.8436 4.41297 35.0003C4.41297 18.1569 18.1773 4.37484 35.0004 4.37484C51.8235 4.37484 65.5879 18.1564 65.5879 34.9997C65.5879 51.8431 51.8235 65.6252 35.0004 65.6252Z" />
      <path d="M48.7649 24.7187L30.6309 42.875L21.4547 33.6879C20.5808 32.8129 19.2699 32.8129 18.396 33.6879C17.522 34.5628 17.522 35.8753 18.396 36.7502L29.1016 47.4688C29.5385 47.9063 29.9755 48.1253 30.6309 48.1253C31.2864 48.1253 31.7233 47.9063 32.1603 47.4688L51.8237 27.7816C52.6976 26.9066 52.6976 25.5941 51.8237 24.7192C50.9497 23.8437 49.6388 23.8437 48.7649 24.7187Z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="70" height="70" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default ConfirmationIcon
